import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../../shared/components/snackbar/snackbar-custom.service'
import { ResponseRequestModel } from '../../../../core/models/response.model'
import { MatInputModule } from '@angular/material/input'
import { AddressTypeService } from '../../../../core/services/address/address-type/address-type.service'
import { MatOption } from '@angular/material/core'
import { MatSelect } from '@angular/material/select'
import { ViaCepService } from '../../../../core/services/address/via-cep/via-cep.service'
import { FormsModule } from '@angular/forms'

@Component({
  selector: 'address-patient-form',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatButton,
    MatProgressSpinner,
    MatInputModule,
    MatOption,
    MatSelect,
  ],
  templateUrl: './address-client-form.component.html',
  styleUrl: './address-client-form.component.scss',
  providers: [AddressTypeService, ViaCepService],
})
export class AddressClientFormComponent implements OnInit, OnChanges {
  constructor(
    private formBuilder: FormBuilder,
    private addressTypeService: AddressTypeService,
    private viaCepService: ViaCepService,
    private snackbar: SnackbarCustomService,
  ) {}

  form: FormGroup = new FormGroup({})
  loading: boolean = false
  @Output() response = new EventEmitter()
  @Input() editItem: any = {}

  ngOnInit(): void {
    this.createForm()
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['editItem']) {
      this.treatmentItem()
    }
  }

  private treatmentItem() {
    if (this.checkEdit()) {
      this.form.reset()
      this.fillForm()
    }
  }

  getAddressByPostalCode() {
    let postalCode = this.form.get('postalCode')?.value
    if (postalCode != '' && postalCode.length >= 8) {
      this.viaCepService.getAdressbyPostalCode(postalCode).subscribe({
        next: (response: any) => {
          this.fillFormViaCep(response)
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
        },
      })
    }
  }

  checkEdit() {
    return !!this.editItem && Object.keys(this.editItem).length > 0
  }

  fillForm() {
    this.form.get('postalCode')?.setValue(this.editItem.cep)
    this.form.get('street')?.setValue(this.editItem.logradouro)
    this.form.get('number')?.setValue(this.editItem.numero)
    this.form.get('complement')?.setValue(this.editItem.complemento)
    this.form.get('neighborhood')?.setValue(this.editItem.bairro)
    this.form.get('city')?.setValue(this.editItem.cidade)
    this.form.get('country')?.setValue(this.editItem.pais)
    this.form.get('state')?.setValue(this.editItem.estado)
  }

  fillFormViaCep(element: any) {
    if (element.erro) {
      this.form.reset()
    } else {
      this.form.get('street')?.setValue(element.logradouro)
      this.form.get('number')?.setValue('')
      this.form.get('complement')?.setValue(element.complemento)
      this.form.get('neighborhood')?.setValue(element.bairro)
      this.form.get('city')?.setValue(element.localidade)
      this.form.get('state')?.setValue(element.estado)
      this.form.get('country')?.setValue('Brasil')
    }
  }

  resetForm() {
    this.form.reset()
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      postalCode: ['', [Validators.required]],
      street: ['', [Validators.required]],
      neighborhood: ['', [Validators.required]],
      complement: [''],
      number: ['', [Validators.required]],
      country: [''],
      state: ['', [Validators.required]],
      city: ['', [Validators.required]],
    })
  }

  createAddress() {
    this.loading = true
    const model = this.createModel()
    this.response.emit({ action: 'create', item: model })
    this.loading = false
    this.snackbar.success('Endereço criado com sucesso!')
  }

  editAddress() {
    this.loading = true
    const model = this.createModel(true)
    this.response.emit({ action: 'edit', item: model })
    this.loading = false
    this.snackbar.success('Endereço editado com sucesso!')

  }

  cancel() {
    this.response.emit({ action: 'cancel' })
    this.resetForm()
    this.snackbar.info('Endereço excluído com sucesso!')
  }

  createModel(edit: boolean = false) {
    if (edit) {
      return {
        idCreate: this.editItem.idCreate,
        cep: this.form.controls['postalCode'].value ?? '',
        logradouro: this.form.controls['street'].value ?? '',
        numero: this.form.controls['number'].value ?? '',
        complemento: this.form.controls['complement'].value ?? '',
        bairro: this.form.controls['neighborhood'].value ?? '',
        estado: this.form.controls['state'].value ?? '',
        cidade: this.form.controls['city'].value ?? '',
        pais: this.form.controls['country'].value ?? '',
      }
    } else {
      return {
        cep: this.form.controls['postalCode'].value ?? '',
        logradouro: this.form.controls['street'].value ?? '',
        numero: this.form.controls['number'].value ?? '',
        complemento: this.form.controls['complement'].value ?? '',
        bairro: this.form.controls['neighborhood'].value ?? '',
        estado: this.form.controls['state'].value ?? '',
        cidade: this.form.controls['city'].value ?? '',
        pais: this.form.controls['country'].value ?? '',
      }
    }
  }
}
